import { render, staticRenderFns } from "./mobileUnit.vue?vue&type=template&id=52d2e747&scoped=true"
import script from "./mobileUnit.vue?vue&type=script&lang=js"
export * from "./mobileUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2e747",
  null
  
)

export default component.exports